/** Approximate real-world wingspan (metres) per aircraft kind for AR sky sizing. */
const WINGSPAN_M: Record<string, number> = {
  presidential: 65,
  government: 22,
  emergency: 40,
  'military-fighter': 14,
  'military-transport': 50,
  'military-other': 35,
  'military-helicopter': 18,
  helicopter: 12,
  balloon: 8,
  'heavy-commercial': 65,
  commercial: 40,
  regional: 30,
  turboprop: 22,
  'private-jet': 20,
  'light-prop': 12,
  glider: 18,
  unknown: 35,
};

const DEFAULT_WINGSPAN_M = WINGSPAN_M.unknown;

/** Minimum on-screen wingspan so distant traffic stays visible in the sky HUD. */
export const AR_MIN_WINGSPAN_PX = 18;

export function arWingspanM(iconKind: string): number {
  return WINGSPAN_M[iconKind] ?? DEFAULT_WINGSPAN_M;
}

/** Slant range from observer to aircraft using ground distance and elevation angle. */
export function slantRangeM(distanceNm: number, elevationDeg: number): number {
  const groundM = distanceNm * 1852;
  const cosEl = Math.cos((elevationDeg * Math.PI) / 180);
  if (cosEl < 0.08) return groundM * 12;
  return groundM / cosEl;
}

/**
 * Boost wingspan when the true angular size would render smaller than `minPx`
 * on screen, using the same linear FOV model as `projectAircraft`.
 */
export function effectiveArWingspanM(
  realWingspanM: number,
  slantM: number,
  fovYDeg: number,
  viewportHeightPx: number,
  minPx = AR_MIN_WINGSPAN_PX,
): number {
  if (slantM <= 0 || viewportHeightPx <= 0 || fovYDeg <= 0) return realWingspanM;
  const angularRad = realWingspanM / slantM;
  const screenPx = (angularRad / ((fovYDeg * Math.PI) / 180)) * viewportHeightPx;
  if (screenPx >= minPx) return realWingspanM;
  return realWingspanM * (minPx / Math.max(screenPx, 0.5));
}
